import { Component } from '@angular/core';

@Component({
	selector: 'form-field-lock',
	templateUrl: './form-field-lock-icon.component.html',
	styleUrls: ['./form-field-lock-icon.component.scss']
})
export class FormFieldLockIconComponent { }